"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
var react_1 = __importDefault(require("react"));
var sideBarStatic_1 = require("@features/SettingsPage/components/LeftMenu/sideBarStatic");
var react_i18next_1 = require("react-i18next");
var permissionManager_1 = require("@common/permissions/permissionManager");
var SideBarItem_1 = require("@features/SettingsPage/components/LeftMenu/SideBarItem");
var getLabel = function (key, t) {
    return t(key);
};
function Sidebar(_a) {
    var currentComponent = _a.currentComponent, domain = _a.domain, angularJsDependencies = _a.angularJsDependencies;
    var t = (0, react_i18next_1.useTranslation)(['settings']).t;
    var filteredSidebar = sideBarStatic_1.SIDEBAR.filter(function (item) {
        var filteredItem = item.states.filter(function (state) {
            var routeName = (0, permissionManager_1.convertRouteForPermission)(permissionManager_1.SETTINGS_ROUTE, { component: state.component });
            return angularJsDependencies.userPermissionManager.hasPermissionToEnterRoute(routeName, domain);
        });
        return filteredItem.length > 0;
    });
    return (react_1.default.createElement("div", { className: "sidebar" },
        react_1.default.createElement("ul", { className: "nav" }, filteredSidebar.map(function (item, indexSection) {
            return (react_1.default.createElement("li", { key: "section".concat(indexSection) },
                react_1.default.createElement("h3", null, getLabel(item.label, t)),
                react_1.default.createElement("ul", { className: "sub-nav" }, item.states.map(function (state, indexItem) {
                    return (react_1.default.createElement(SideBarItem_1.SideBarItem, { key: "item".concat(indexSection).concat(indexItem), label: getLabel(state.label, t), domain: domain, component: state.component, isActive: currentComponent === state.component, angularJsDependencies: angularJsDependencies }));
                }))));
        }))));
}
exports.Sidebar = Sidebar;
